import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import SelectedStateIndicator from "@/components/SelectedStateIndicator";
import {
  listItemCss,
  listItemButtonCss,
} from "../ReadAloudOptions/ReadAloudOptions.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  ariaProps: PropTypes.object,
  dataProps: PropTypes.object,
  eventProperties: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelectOption: PropTypes.func,
  speed: PropTypes.object,
};

const ReadAloudSpeedOption = ({
  speed,
  isSelected,
  eventProperties,
  ariaProps,
  dataProps,
  onSelectOption,
}) => {
  const { label } = speed;

  return (
    <li key={speed} css={listItemCss}>
      <ButtonWithTrackEvent
        {...eventProperties}
        flavor={Button.flavors.tertiary}
        ariaProps={ariaProps}
        dataProps={dataProps}
        onClick={() => onSelectOption(speed)}
        __cssFor={{ root: listItemButtonCss }}
      >
        <SelectedStateIndicator shouldDisplay={isSelected} />
        <span>{label}</span>
      </ButtonWithTrackEvent>
    </li>
  );
};

ReadAloudSpeedOption.propTypes = propTypes;

export default ReadAloudSpeedOption;
